import moment from "moment";


export function validateEmail(email: string) {
    let re = /^(([^<>()\\,;:\s@"]+(\.[^<>().,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export function validatePhone(phone: string) {
    return /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(phone);
}
function removeAscent(str: string) {
    if (str === null || str === undefined) return str;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    return str;
}

export function slugify(string: string) {
    const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
    const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return string.toString().toLowerCase()
        .replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a')
        .replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e')
        .replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i')
        .replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o')
        .replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u')
        .replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y')
        .replace(/đ/gi, 'd')
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
}

export function validateFullName(string: string) {
    var re = /^[a-zA-Z ]{2,}$/g;
    return re.test(removeAscent(string))
}

export function urlParseParams(objectParse: any = {}) {
    const str = [];
    for (const p in objectParse)
        if (objectParse.hasOwnProperty(p)) {
            if (objectParse[p] !== '' && objectParse[p] !== null) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(objectParse[p]));
            }
        }
    return str.join("&");
}

export function formatMoney(x: string, decimal: number = 0) {
    if (x) {
        const format = parseFloat(x).toFixed(decimal)
        return format.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return x
    }
}

export function getUrlDevLink() {
    const URL_GET_FROM_ENV = process?.env?.REACT_APP_DEV_LINK || 'https://apipub.dsc.com.vn/fta'
    return URL_GET_FROM_ENV;
}

export function getUrlPriceLink() {
    const URL_GET_FROM_ENV = process?.env?.REACT_APP_PRICE_STOCK || 'https://apidev.dsc.com.vn/webtrading/datafeed/instruments?symbol=DSC'
    return URL_GET_FROM_ENV;
}

export const checkTimeOutData = (dataStore: any) => {
    if (dataStore) {
        const parseData = JSON.parse(dataStore)
        if (parseData?.time < moment().valueOf()) {
            return { value: true, data: null };
        } else {
            return { value: false, data: parseData?.data };
        }
    } else {
        return { value: true, data: null };
    }
}

export const getDegLine = (a: any, b: any, c: any, d: any) => {
    const point = { x: c - a, y: d - b }
    const pointMiddle = { x: 0, y: 0 }
    const pointCompare = { x: 5, y: 0 }
    const vector1 = { x: pointCompare.x - pointMiddle.x, y: pointCompare.y - pointMiddle.y }
    const vector2 = { x: pointMiddle.x - point.x, y: pointMiddle.y - point.y }
    const valuex1 = vector1.x
    const valuex2 = vector2.x
    const valuey1 = vector1.y
    const valuey2 = vector2.y
    const valueHeader = valuex1 * valuex2 + valuey1 * valuey2
    const valueFooter = Math.sqrt(Math.pow(valuex1, 2) + Math.pow(valuey1, 2)) * Math.sqrt(Math.pow(valuex2, 2) + Math.pow(valuey2, 2))
    const deg = valueHeader / (valueFooter)
    const degrees = (180 * deg) / Math.PI
    // console.log(degrees, vector1, vector2, valuex1, deg, valuex2, valuey1, valuey2, valueHeader, valueFooter, '1111111');
    return degrees
}

export const compareValue = (value: string) => {
    let color = '#ffffff'
    if (value === 'A') {
        color = '#22ab24'
    } else if (value === 'B') {
        color = '#83c400'
    } else if (value === 'C') {
        color = '#ffc400'
    } else if (value === 'D') {
        color = '#ff4230'
    }
    return color
}

export const getMaxMinValueList = (data: any, min: any, max: any) => {
    let maxNew = max
    let minNew = min
    if (data && data.length > 0) {
        data.map((item: any) => {
            if (item > maxNew) {
                maxNew = item
            }
            if (item < minNew) {
                minNew = item
            }
        })
    }

    return { max: maxNew, min: minNew }
}

export function makeid(length: number) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}


export const getCategoryValueColor = (category: any) => {
    let color = '#ffffff'
    let linePath = ''
    if (category === 'recuperate') {
        color = '#2AD03D'
        linePath = '2'
    } else if (category === 'increase') {
        color = '#9B51E0'
        linePath = '3'
    } else if (category === 'weaken') {
        color = '#F7931A'
        linePath = '4'
    } else if (category === 'plummeted') {
        color = '#d61e4a'
        linePath = '5'
    }
    return { color: color, linePath: linePath }
}

export const styleCommon: any = {
    xuhuong: {
        S1440: { height: 650, x: 20, y: -15, fontSize: '14px', point: 12, lineWith: 2 },
        S1366: { height: 550, x: 20, y: -15, fontSize: '14px', point: 12, lineWith: 2 },
        S1200: { height: 520, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S1000: { height: 550, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S850: { height: 520, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S700: { height: 450, x: 10, y: -12, fontSize: '10px', point: 10, lineWith: 2 },
        S450: { height: 430, x: 10, y: -12, fontSize: '10px', point: 10, lineWith: 2 },
        S360: { height: 310, x: 10, y: -12, fontSize: '9px', point: 10, lineWith: 2 },
        S300: { height: 310, x: 10, y: -12, fontSize: '9px', point: 10, lineWith: 2 },
    },
    xuhuongthegioi: {
        S1440: { height: 320, x: 20, y: -15, fontSize: '14px', point: 16, lineWith: 2 },
        S1366: { height: 250, x: 20, y: -15, fontSize: '14px', point: 12, lineWith: 2 },
        S1200: { height: 250, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S1000: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S850: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S700: { height: 500, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S450: { height: 360, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S360: { height: 290, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S300: { height: 200, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
    },
    xuhuongthegioimodal: {
        S1440: { height: 470, x: 20, y: -15, fontSize: '14px', point: 16, lineWith: 2 },
        S1366: { height: 550, x: 20, y: -15, fontSize: '14px', point: 12, lineWith: 2 },
        S1200: { height: 250, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S1000: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S850: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S700: { height: 500, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S450: { height: 360, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S360: { height: 290, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S300: { height: 200, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
    },
    xuhuongdongtienbranch: {
        S1440: { height: 700 },
        S1366: { height: 550 },
        S1200: { height: 520 },
        S1000: { height: 550 },
        S850: { height: 520 },
        S700: { height: 450 },
        S450: { height: 430 },
        S360: { height: 310 },
        S300: { height: 310 },
    },
    dongluong: {
        S1440: { height: 680, x: 20, y: -15, fontSize: '14px', point: 16, lineWith: 2 },
        S1366: { height: 550, x: 20, y: -15, fontSize: '14px', point: 12, lineWith: 2 },
        S1200: { height: 250, x: 10, y: -12, fontSize: '12px', point: 10, lineWith: 2 },
        S1000: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S850: { height: 600, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S700: { height: 500, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S450: { height: 360, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S360: { height: 290, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
        S300: { height: 200, x: 10, y: -12, fontSize: '8px', point: 10, lineWith: 2 },
    },
}

export const getStyleChart = (CommnonStore: any, type: string) => {
    let dataStyle: any = {}
    if (CommnonStore?.innerWidthScreen > 1440) {
        dataStyle = styleCommon[type]['S1440'];
    } else if (CommnonStore?.innerWidthScreen > 1366) {
        dataStyle = styleCommon[type]['S1366'];
    } else if (CommnonStore?.innerWidthScreen > 1200) {
        dataStyle = styleCommon[type]['S1200'];
    } else if (CommnonStore?.innerWidthScreen > 1000) {
        dataStyle = styleCommon[type]['S1000'];
    } else if (CommnonStore?.innerWidthScreen > 850) {
        dataStyle = styleCommon[type]['S850'];
    } else if (CommnonStore?.innerWidthScreen > 700) {
        dataStyle = styleCommon[type]['S700'];
    } else if (CommnonStore?.innerWidthScreen > 450) {
        dataStyle = styleCommon[type]['S450'];
    } else if (CommnonStore?.innerWidthScreen > 360) {
        dataStyle = styleCommon[type]['S360'];
    } else if (CommnonStore?.innerWidthScreen > 300) {
        dataStyle = styleCommon[type]['S300'];
    }

    return dataStyle
}

export function getParamsUrl(url: any) {
    let urlReplace = url.replace('?', '');
    let itemStock = null
    let urlList = []
    if (urlReplace) {
        urlList = urlReplace.split('&')
        itemStock = urlList?.[0].split('=')
    }
    return itemStock;
}